var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentReceipt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.25V3.75H6V5.25H10.125C10.9528 5.25243 11.7507 5.55967 12.3663 6.11304C12.9819 6.66642 13.3722 7.42716 13.4625 8.25H6V9.75H13.4625C13.3722 10.5728 12.9819 11.3336 12.3663 11.887C11.7507 12.4403 10.9528 12.7476 10.125 12.75H6V14.5087L13.2128 21L14.2162 19.8855L7.9545 14.25H10.125C11.3521 14.2482 12.5334 13.784 13.4334 12.95C14.3335 12.116 14.8862 10.9734 14.9813 9.75H18V8.25H14.9813C14.8953 7.1238 14.4192 6.06285 13.635 5.25H18Z",
    fill: "#374151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentReceipt);
export default __webpack_public_path__ + "static/media/PaymentReceipt .bac5285e4783d268bc0434e5cb896b77.svg";
export { ForwardRef as ReactComponent };